<style scoped></style>
<template>
  <swiper-content isProduct>
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout page-layout-product">
          <img src="./products/watchSE-image.png" class="product-image" />

          <div class="content">
            <img
              src="./products/watchSE-logo.svg"
              class="product-logo"
              style="margin-top: -1vh; max-width: 25%"
            />
            <h2>
              Heavy on features. <br />
              Light on price.
            </h2>
            <p>
              Apple Watch SE combines the largest Apple Watch display and most
              essential features of Apple Watch. All from just $499.
            </p>
            <a
              target="_blank"
              href="https://www.singtel.com/personal/products-services/mobile/accessories?deal=singtel:rrp/rrp-accessory-deals/apple-watch&utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=applewatch-se-buynow&utm_campaign=iphone-2020-launch "
              class="st-button-red-outline page-button"
            >
              Buy Now
            </a>
            <a
              target="_blank"
              href="https://www.singtel.com/personal/products-services/mobile/info/applewatch-se?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=applewatch-se-learnmore&utm_campaign=iphone-2020-launch"
              class="st-button-red-outline page-button"
            >
              Learn More
            </a>

            <p class="small">T&amp;Cs apply.</p>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-content>
</template>

<script>
import "swiper/swiper-bundle.css";

export default {
  name: "WatchSEPage",
  data: function () {
    return {};
  },
  props: {
    contentEnabled: Boolean,
  },
  methods: {},
};
</script>

<style scoped></style>
